<template>
  <div :class="{ 'w-full': fullWidth }">
    <el-select
      ref="select"
      :class="{ 'w-full': fullWidth }"
      v-model="lookalikeUserLists"
      placeholder="选择相似受众"
      :disabled="disabled"
      value-key="id"
      filterable
      multiple
      @change="emitMsg"
    >
      <!-- 创建相似受众选项 -->
      <el-option
        value="create-lookalike"
        label="创建相似受众"
        v-if="!isEdit"
      >
        <div
          class="flex items-center"
          @click.stop="openLookalikeDialog"
        >
          <el-button
            type="text"
            icon="el-icon-plus"
            class="text-blue-500 hover:text-blue-600"
          />
          <span>创建相似受众</span>
        </div>
      </el-option>
      <el-option
        v-for="item in lookalikeDataList"
        :key="item.resourceName"
        :label="item.name"
        :value="item"
      >
        <div class="flex justify-between">
          <span>{{ item.name }}</span>
          <span>{{ item.size }}</span>
        </div>
      </el-option>
    </el-select>
    <!-- 创建相似受众弹窗 -->
    <LookalikeDialog
      :visible.sync="lookalikeDialogVisible"
      :currentAccount="currentAccount"
      :data="data"
      :audienceData="audienceData"
      :enumConstants="enumConstants"
      @confirm="handleLookalikeConfirm"
    />
  </div>
</template>
<script>
import { lookalikeList } from '@/api/google/create';
import LookalikeDialog from './LookalikeDialog.vue';

export default {
  components: {
    LookalikeDialog,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
    audienceData: {
      type: Object,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    enumConstants: {
      type: Object,
      default: () => {},
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    defaultList:{
        type:Array,
        default:()=>[]
    }
  },
  data() {
    return {
      lookalikeDataList: [],
      lookalikeUserLists: [],
      lookalikeDialogVisible: false,
    };
  },
  watch: {
    value: {
      handler() {
        this.lookalikeUserLists = this.value;
      },
      deep: true,
      immediate: true,
    },
    defaultList: {
      handler() {
        if (this.defaultList && this.defaultList.length > 0) {
          this.lookalikeDataList = this.defaultList;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getLookalikeList() {
      let res = await lookalikeList({ accountId: this.currentAccount.id });
      console.log(res, 'lookalikeDataList');
      this.lookalikeDataList = res.data || [];
      this.$emit('setLikeAudienceList', this.lookalikeDataList);
      this.$nextTick(() => {
        this.lookalikeUserLists = this.value;
      });
    },
    // 导出数据
    emitMsg() {
      // 检查是否选中了创建相似受众选项
      if (this.lookalikeUserLists.includes('create-lookalike')) {
        this.openLookalikeDialog();
        return;
      }
      this.$emit('input', this.lookalikeUserLists);
    },
    // 打开创建相似受众弹窗
    openLookalikeDialog() {
      // 移除创建相似受众选项如果被选中
      this.lookalikeUserLists = this.lookalikeUserLists
        ? this.lookalikeUserLists.filter((item) => item !== 'create-lookalike')
        : null;
      this.lookalikeDialogVisible = true;
      // 关闭下拉框
      this.$refs.select && this.$refs.select.blur();
    },
    // 处理创建相似受众确认
    handleLookalikeConfirm(formData) {
      console.log('相似受众数据:', formData);
      this.getLookalikeList();
    },
  },
};
</script>
<style lang="scss" scoped></style>
